var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartoComponentsLogoNegativeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.043 40C93.065 40 102 31.046 102 20S93.065 0 82.043 0C71.022 0 62.087 8.954 62.087 20s8.935 20 19.956 20z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.932 26.646c2.788 0 4.4-1.22 5.595-2.879l-2.644-1.895c-.76.93-1.538 1.549-2.86 1.549C5.249 23.42 4 21.927 4 20.013v-.036c0-1.859 1.249-3.39 3.023-3.39 1.213 0 2.046.602 2.77 1.495l2.643-2.06c-1.122-1.548-2.788-2.642-5.377-2.642-3.838 0-6.662 2.916-6.662 6.633v.037c0 3.808 2.915 6.596 6.535 6.596zm11.619-.255h3.675l.905-2.296h4.906l.905 2.296h3.766l-5.395-12.847h-3.385L18.55 26.391zm5.612-5.047l1.43-3.608 1.412 3.608h-2.842zm15.384 5.047h3.512v-3.863h1.557l2.553 3.863h4.037l-3.024-4.446c1.575-.674 2.607-1.968 2.607-3.936v-.037c0-1.257-.38-2.223-1.122-2.97-.851-.856-2.19-1.366-4.128-1.366h-5.992V26.39zm3.512-6.633v-3.08h2.317c1.159 0 1.901.51 1.901 1.531v.037c0 .93-.706 1.512-1.883 1.512H43.06zm38.984-6.425c3.674 0 6.653 2.985 6.653 6.667s-2.979 6.667-6.653 6.667c-3.673 0-6.652-2.985-6.652-6.667s2.979-6.667 6.652-6.667zm-13.462.303v3.097H64.78v9.658h-3.512v-9.658h-3.784v-3.097h11.098z"
  }))));
}

export default __webpack_public_path__ + "17b52d16eb9c7ce30ae0a1e35ed2925f.svg";
export { SvgCartoComponentsLogoNegativeLogo as ReactComponent };